import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'
import { Store } from '@ngrx/store'
import { EnvironmentModel } from 'apps/gb-dashboard/src/environments/environment.model'
import * as AccountActions from 'libs/gb-dashboard/account/data-access/src/lib/+state/account.actions'
import { GbDashboardAuthService } from 'libs/gb-dashboard/account/utils/src/lib/gb-dashboard-auth-service/gb-dashboard-auth.service'
import { APP_CONFIG } from 'libs/shared/app-config/src/lib/gb-app-config'
import { BaseAuthInterceptor } from 'libs/shared/utils/interceptors/src/lib/base-auth-interceptor'
import { Observable, throwError } from 'rxjs'
import { GbDashboardPusherService } from 'libs/gb-dashboard/core/util/src/lib/gb-dashboard-pusher-service/gb-dashboard-pusher.service'

/**
 * Interceptor which handles attaching an auth header to http request for authenticated users,
 * and refreshing the auth token as necessary.
 */
@Injectable()
export class GbDashboardAuthInterceptor<T> extends BaseAuthInterceptor<T> {
  constructor(
    protected store: Store,
    protected gbDashboardAuthService: GbDashboardAuthService,
    @Inject(APP_CONFIG) protected appConfig: EnvironmentModel,
    private gbDashboardPusherService: GbDashboardPusherService,
  ) {
    super(store, gbDashboardAuthService, AccountActions.refreshToken, appConfig)
  }

  intercept(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    const token = this.gbBaseAuthService.getAccessToken()

    if (
      !req.withCredentials ||
      !req.url.includes(this.appConfig.baseApiUrl) ||
      ['logout', 'register', 'verify-client-account-user-invite'].some((endpoint) => req.url.endsWith(`/${endpoint}/`))
    ) {
      return next.handle(req)
    }

    if (!token && !req.url.includes('/login/')) {
      this.store.dispatch(AccountActions.logout(true))
      return throwError(() => new Error('Token invalid or empty'))
    }

    const socketId = this.gbDashboardPusherService.getPusherSocketId()
    let headers = {}
    // in some api service to avoid being skip on the next pusher event
    // we pass x-realtime-id: '' and then it will not set the socketId.
    if (!req.headers.has('x-realtime-id') && socketId) {
      headers = { headers: req.headers.append('x-realtime-id', socketId) }
    }

    const modifiedReq = req.clone(headers)
    return super.handleRequest(modifiedReq, next, token)
  }
}
